import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import orgTree from '../../../components/org-tree/org-tree.vue';
import { structureBranch, delStructure } from './request';
import companyModel from './companyModel.vue';
import { structureResource } from './../staffManage/request';
export default {
  components: {
    orgTree,
    companyModel
  },
  data() {
    return {
      data: {},
      horizontal: false,
      collapsable: false,
      expandAll: true,
      companyShow: false,
      labelClassName: 'bg-white',
      form: {
        childrenStructureId: undefined
      },
      resourceList: [],
      show: false
    };
  },
  created() {
    this.getDataFun();
    structureResource({
      customerId: this.$route.params.customerId,
      structureId: this.$route.params.id == 0 ? undefined : this.$route.params.id
    }).then(res2 => {
      this.resourceList = res2;
    });
  },
  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    getDataFun() {
      structureBranch({
        customerId: this.$route.params.customerId,
        structureId: this.$route.params.id == 0 ? undefined : this.$route.params.id,
        childrenStructureId: this.form.childrenStructureId
      }).then(res => {
        console.log(res);
        this.data = res[0];
      });
    },
    renderContent(h, data) {
      return data.id == 0 ? h("div", [h("div", {
        "class": "title",
        "style": "line-height:30px"
      }, [data.name]), h("div", {
        "class": "num",
        "style": "border-top: 1px solid #f5f5f5;color:#1890ff;line-height:30px"
      }, [this.$t('员工数'), ":", data.workerNum, this.$t('人')]), h("div", {
        "class": "footer"
      }, [h("i", {
        "class": "el-icon-circle-plus-outline",
        "on": {
          "click": () => this.onAddHandle(data, true)
        },
        "style": "font-size:16px;"
      })])]) : h("div", [h("div", {
        "class": "title",
        "style": "line-height:30px"
      }, [data.name]), h("div", {
        "class": "num",
        "style": "border-top: 1px solid #f5f5f5;color:#1890ff;line-height:30px"
      }, [this.$t('员工数'), ":", data.workerNum, this.$t('人')]), h("div", {
        "class": "footer"
      }, [h("i", {
        "class": "el-icon-circle-plus-outline",
        "on": {
          "click": () => this.onAddHandle(data, true)
        },
        "style": "font-size:16px;margin-right: 5px;"
      }), h("i", {
        "class": "el-icon-edit-outline",
        "on": {
          "click": () => this.onAddHandle(data, false)
        },
        "style": "font-size:16px;margin-right: 5px;"
      }), h("i", {
        "class": "el-icon-delete",
        "on": {
          "click": () => this.onDeleteHandle(data)
        },
        "style": "font-size:16px;"
      })])]);
      // <div class="num" style="border-top: 1px solid #f5f5f5;line-height:30px">组织类型:部门</div>
      // return (
      //   <div class="frameworkItem">
      //     <div class="title" style="line-height:30px;color:#1890ff">{data.name}</div>
      //     <div class="num" style="border-top: 1px solid #f5f5f5;line-height:30px">组织类型:{data.orgTypeName}</div>
      //     <div class="footer">
      //       <i class="el-icon-circle-plus-outline" onClick={() => this.onAddHandle(data)} style="font-size:16px;margin-right: 5px;" ></i>
      //       <i class="el-icon-edit-outline" onClick={() => this.onEditHandle(data)} style="font-size:16px;margin-right: 5px;" ></i>
      //       <i class="el-icon-delete" onClick={() => this.onDeleteHandle(data)} style="font-size:16px;" ></i>
      //     </div>
      //   </div>
      // )
    },
    // renderContent(h, data) {
    //   return data.label;
    // },
    // onExpand(e,data){
    //   console.log(e,data)
    // },
    onExpand(e, data) {
      if ('expand' in data) {
        data.expand = !data.expand;
        if (!data.expand && data.children) {
          this.collapse(data.children);
        }
      } else {
        this.$set(data, 'expand', true);
      }
    },
    onNodeClick(e, data) {
      this.$message.success(data.label);
      // alert(data.label);
    },
    onNodeMouseover(e, data) {
      console.log(e, data);
    },
    collapse(list) {
      var _this = this;
      list.forEach(function (child) {
        if (child.expand) {
          child.expand = false;
        }
        child.children && _this.collapse(child.children);
      });
    },
    expandChange() {
      this.toggleExpand(this.data, this.expandAll);
    },
    toggleExpand(data, val) {
      var _this = this;
      if (Array.isArray(data)) {
        data.forEach(function (item) {
          _this.$set(item, 'expand', val);
          if (item.children) {
            _this.toggleExpand(item.children, val);
          }
        });
      } else {
        this.$set(data, 'expand', val);
        if (data.children) {
          _this.toggleExpand(data.children, val);
        }
      }
    },
    onDeleteHandle(val) {
      if (!this.isAuth('home.companyStructureDelete')) {
        this.$message.error(this.$t('暂无权限'));
        return false;
      }
      let _this = this;
      this.$alert(this.$t('是否确认删除该架构') + '?', {
        confirmButtonText: this.$t('确定')
      }).then(() => {
        delStructure({
          customerId: _this.$route.params.customerId,
          structureId: val.id
        }).then(res => {
          _this.$message.success(this.$t('删除成功'));
          _this.getDataFun();
        });
      });
    },
    onAddHandle(data, type) {
      if (type) {
        if (!this.isAuth('home.companyStructureStore')) {
          this.$message.error(this.$t('暂无权限'));
          return false;
        }
      } else {
        if (!this.isAuth('home.companyStructureEdit')) {
          this.$message.error(this.$t('暂无权限'));
          return false;
        }
      }
      this.companyShow = true;
      data.customerId = this.$route.params.customerId;
      this.$nextTick(() => {
        this.$refs.companyForm.init(data, type);
      });
    }
  }
};